//export class CloneAddress {
//    static readonly type = '[Contract.Address] Clone Address';
//    constructor(public addressID: number, public copies: number = 1) { }
//}

export class DeleteAddress {
  static readonly type = '[Contract.Address] Delete Address';
  constructor(public entityID: string, public addressID: number) {}
}

export class RestoreAddress {
  static readonly type = '[Contract.Address] Restore Address';
  constructor(public addressID: number) {}
}

export class CloneAddress {
  static readonly type = '[Contract.Address] Clone Address';
  constructor(public entityID: string, public addressID: number) {}
}

export class AddAddress {
  static readonly type = '[Contract.Address] Add Address';
  constructor(public entityID: string, public address: any) {}
}

export class UpdateAddress {
  static readonly type = '[Contract.Address] Update Address';
  constructor(public entityID: string, public address: any) {}
}

export class SetThirdPartyAddresses {
  static readonly type = '[Contract.Address] Set Third Party Addresses';
  constructor(public addresses: any) {}
}

export class ClearThirdPartyAddress {
  static readonly type = '[Contract.Address] Clear Third Party Address';
  constructor(public addressID: number) {}
}
